import { Component, OnInit, ChangeDetectionStrategy, Inject, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

import { Organization } from 'src/app/services/organization.model';
import { forkJoin, Observable } from 'rxjs';
import { OrganizationService } from '../../organization/organization.service';
import { AuthService } from 'src/app/auth.service';

@Component({
    selector: 'app-create-companyuser-dialog',
    templateUrl: './create-companyuser-dialog.component.html',
    styleUrls: ['./create-companyuser-dialog.component.css'],
    standalone: false
})
export class CreateCompanyuserDialogComponent implements OnInit {

  public userdata: any;
  public userorgdata: any;
  dialogTitle: string;
  organizations: Organization[] = [];
  hasError: boolean = false;
  selectedOrganizationIds: number[] = []; // Define selectedOrganizationIds here
  isPlaceholderVisible: boolean = true;
  userTypes = [
   { id: 1, label: 'Super Admin' },
    { id: 2, label: 'Admin' },
    { id: 3, label: 'Analyst' },
    { id: 4, label: 'Operator' }
  ];
  currentEmail: string;
  newInputEmail: string;
  statusOptions = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'In-Active' }
  ];

  phonePattern = '^((\\+\\d{1,3}[- ]?)?\\(?\\d{1,4}\\)?[- ]?\\d{1,4}[- ]?\\d{1,4}[- ]?\\d{1,4}|\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{3})$';
  filteredOrganizations = [];
  filteredUserTypes = [];
  suserType: number | null = null;

 
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private organizationService: OrganizationService,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    private dialogRef: MatDialogRef<CreateCompanyuserDialogComponent>
  ) {
    this.dialogTitle = data?.title ?? 'Create Comapny User';
    this.userdata = data?.user ? { ...data.user } : this.initializeEmptyUserData();
    this.currentEmail=data?.user ?.emailAddress;
   
  }
   ngOnInit(): void {
   // this.loadOrganizations();
    // Optionally trigger change detection here if necessary
   // this.cdRef.detectChanges();
   this.suserType = this.authService.getUserDetails().userType;
   //console.log("Logged-in User Type:", this.suserType);
  // console.log("userType",this.userType);
  this.filterUserTypes();
  }
  filterUserTypes(): void {
    if (this.suserType === 1) {
      // Show all options for Super Admin
      this.filteredUserTypes = this.userTypes;
    } else {
      // Exclude "Super Admin" for other users
      this.filteredUserTypes = this.userTypes.filter(user => user.id !== 1);
    }
  }

  private initializeEmptyUserData() {
    return {
      userId: '',
      userName: '',
      password: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      userType: '',
      primaryPhone: '',
      title: '',
      notes: '',
      status: 1,
    };
  }


  onSave(): void {
    
  const isEditMode = !!this.data.user; // Determine if in edit mode or create mode

  // Step 2: If it is edit mode, check if organizationsTranctionid exists (indicating that user organizations need to be deleted)
  if (isEditMode ) {
    this.createOrUpdateUser(isEditMode);
  } else {
    // If not in edit mode or no organizations to delete, continue directly with user create or update
    this.createOrUpdateUser(isEditMode);
  }
  }
 
  async createOrUpdateUser(isEditMode: boolean): Promise<void> {
    try {


      
      this.newInputEmail=this.userdata.emailAddress;
      console.log("cureent",this.currentEmail);
      console.log("newInputEmail",this.newInputEmail);

      if (this.currentEmail !== this.newInputEmail) {
        // If emails are different, call the checkEmailExist API
        const emailCheckResponse = await this.userService.checkEmailExists(this.newInputEmail);
        if (!emailCheckResponse.status) {
          console.error('Error: Email already exists');
          this.dialogRef.close({
            status: false,
            message: emailCheckResponse.message
          });
          return; // Exit early if the email already exists
        }
      }
    
      // Step 1: Determine whether to update or create the user
      const userResponse = isEditMode
        ? await this.userService.updateUser(this.userdata)
        : await this.userService.createUser(this.userdata);
  
      // Check if the API response has a status of false (error)
      if (userResponse.status === false) {
        // If status is false, log the error and return early to prevent further actions
        console.error('Error:', userResponse.message);
        
        // Close the dialog with the status and message from the API response
        this.dialogRef.close({
          status: false,
          message: userResponse.message || 'An error occurred during the operation.'
        });
        
        return;  // Exit the function early to prevent further execution
      }
  
  
      // Step 3: Close the dialog with the success response and message
      this.dialogRef.close({ 
        status: true, 
        user: userResponse,  // Pass the userResponse back when closing the dialog
        message: userResponse.message || 'Operation completed successfully'
      });
  
    } catch (error) {
      console.error(isEditMode ? 'Error updating user:' : 'Error creating user:', error);
  
      // Step 4: Handle the error by closing the dialog with an error message
      const errorMessage = error?.message || 'An error occurred during the operation.';
      this.dialogRef.close({
        status: false,
        message: errorMessage  // Pass error message from the exception
      });
    }
  }
  
  onCancel(): void {
    this.dialogRef.close();
  }
  
}
